import { ShippingMethodType } from '@/helpers/entities/enums/v2/ShippingMethodType';
import { omit } from 'lodash';
import { PickupPointModel } from '@/helpers/entities/models/PickupPointModel';
export class ShippingMethodModel {
    constructor(payload) {
        this.shippingType = ShippingMethodType.Internal;
        this.thirdPartyProvider = null;
        this.pickupPoints = null;
        const params = omit(payload, 'pickupPoints');
        Object.assign(this, params);
        const { zone } = payload;
        this.zoneName = zone?.name || '';
        const { pickupPoints } = payload;
        if (!!pickupPoints && pickupPoints.edges.length >= 1) {
            this.pickupPoints = pickupPoints.edges.map((pp) => {
                return new PickupPointModel(pp.node);
            });
        }
    }
    get isThirdParty() {
        return this.shippingType === ShippingMethodType.ThirdParty;
    }
}
